import { render, staticRenderFns } from "./NewsShow.vue?vue&type=template&id=473cd515&scoped=true&"
import script from "./NewsShow.vue?vue&type=script&lang=js&"
export * from "./NewsShow.vue?vue&type=script&lang=js&"
import style0 from "./NewsShow.vue?vue&type=style&index=0&id=473cd515&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473cd515",
  null
  
)

export default component.exports